//import logger from './logger';

// config.js


export const spareka={ urlVisio: "https://www.spareka.fr/aide-reparation-en-ligne#rdv"};
console.log("SERVER_IP =", process.env.REACT_APP_BACKEND_IP);

console.log("API_VERSION =", process.env.REACT_APP_BACKEND_API_VERSION);

const config = {
   
    serverIP: process.env.REACT_APP_BACKEND_IP,
    apiVersion: process.env.REACT_APP_BACKEND_API_VERSION,
    SPAREKA_VISO: "https://www.spareka.fr/pieces_detachees_accessoires_electromenager?",

  };
  
  
export default config;
  